import { render, staticRenderFns } from "./CardPackages.vue?vue&type=template&id=5192a88c&"
import script from "./CardPackages.vue?vue&type=script&lang=js&"
export * from "./CardPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports